import React from 'react'
import intl from 'react-intl-universal'
import Input from 'components/shared/input/Input'
import { Button, FormGroup, Modal, ModalBody } from 'components/qstrap'
import { cookie } from 'cookie_js'
import API from 'utils/API'
import AccessToken from 'utils/AccessToken'
import csrfToken from 'utils/csrfToken'
import hotjarTrigger from 'utils/hotjarTrigger'
import { branch } from 'baobab-react/higher-order'
import config from 'config'

class Application extends React.Component {
  constructor(props) {
    super(props)

    this.inputs = {}
    this.container = {}

    this.handleSubmit = this.handleSubmit.bind(this)
    this.fillCityOptions = this.fillCityOptions.bind(this)
    this.showSchoolSelect = this.showSchoolSelect.bind(this)
    this.setSchoolMajor = this.setSchoolMajor.bind(this)
    this.customSchoolToggle = this.customSchoolToggle.bind(this)

    this.fields = ['province', 'city', 'school', 'custom_school', 'grade_level', 'school_major', 'phone_number', 'parent_phone_number']

    this.state = {
      provinces: [],
      provincesLoading: false,

      cities: [],
      citiesVisible: false,
      citiesLoading: false,

      schools: [],
      schoolsVisible: false,

      gradeLevels: [],
      gradeLevelsLoading: false,

      majors: [],
      majorsVisible: false,

      customSchoolInput: false,
      openNotice: true,
    }
  }

  componentWillMount() {
    this.fillProvinceOptions()
    this.fillGradesOptions()
  }

  componentDidMount() {
    if (this.props.currentUser.grade_level) {
      this.setSchoolMajor()
    }
  }

  setSchoolMajor() {
    const grade = this.attributes().grade_level
    if (['g10', 'g11', 'g12'].includes(grade)) {
      this.setState({ majorsVisible: true })
    } else {
      this.setState({ majorsVisible: false })
      this.inputs.school_major.value = 'not_yet_decided'
    }
  }

  fillGradesOptions() {
    const getGradesPath = `${API.endPoints().schools.grades}/id`

    this.setState({ gradeLevelsLoading: true }, () => {
      API.get(getGradesPath).then((response) => {
        let grades = response.data.map(grade => grade.slug).reverse()
        // exclude under_g9 grade slug code for quipper campus
        grades = grades.filter(e => new RegExp(/^(g9|g10|g11|g12|over_g12)$/).test(e))

        this.setState({
          gradeLevels: grades,
          gradeLevelsLoading: false,
        })
      })
    })
  }

  showSchoolSelect(validity) {
    this.clearInputValue('school')
    if (validity) {
      const hashValues = this.attributes()

      this.setState({
        schoolsAjaxSource: `${API.endPoints().schools.select}?country_code=ID&province=${hashValues.province}&city=${hashValues.city}&limit=50&verified_only=true`,
        schoolsVisible: true,
      })
    }
  }

  fillCityOptions(validity, value) {
    this.clearInputValue('city')
    this.clearInputValue('school')

    if (validity) {
      const getCitiesPath = `${API.endPoints().schools.cities}?country_code=ID&province=${value}`
      const initialLoadStates = {
        citiesLoading: true,
        citiesVisible: true,
        schoolsVisible: false,
      }

      this.setState(initialLoadStates, () => {
        API.get(getCitiesPath).then((response) => {
          this.setState({
            cities: response.data,
            citiesLoading: false,
          })
        })
      })
    }
  }

  fillProvinceOptions() {
    const getProvincesPath = `${API.endPoints().schools.provinces}?country_code=ID`
    const initialLoadStates = {
      provincesLoading: true,
      citiesVisible: false,
      schoolsVisible: false,
    }

    this.setState(initialLoadStates, () => {
      API.get(getProvincesPath).then((response) => {
        this.setState({
          provinces: response.data,
          provincesLoading: false,
        })
      })
    })
  }

  clearInputValue(name) {
    this.inputs[name].value = undefined
    this.inputs[name].setState({ clientSideErrors: [] })
  }

  isValid() {
    return !this.fields.map(field => this.inputs[field].validate()).includes(false)
  }

  attributes() {
    const hash = {}
    this.fields.map(field => hash[field] = this.inputs[field].value)
    return hash
  }

  handleSubmit(e) {
    e.preventDefault()
    this.loader.classList.remove('hide')
    const { currentUser } = this.props

    if (this.isValid()) {
      const hash = this.attributes()
      const data = {
        province: hash.province,
        city: hash.city,
        grade_level: hash.grade_level,
        phone_number: hash.phone_number,
        parent_phone_number: hash.parent_phone_number,
        school_major: hash.school_major,
        existing_user: true,
        country_code: 'ID',
        email: currentUser.email,
        name: currentUser.name,
        username: currentUser.username,
      }

      if (this.state.customSchoolInput) {
        data.school_name = hash.custom_school
      } else {
        data.school_id = hash.school
        data.school_name = this.inputs.school.inputTag.textValue
      }

      API.post(API.endPoints().auth.vp_meta, data, { headers: { 'X-CSRF-Token': csrfToken() } }).then(() => {
        API.post(API.endPoints().profile.updateApi, {
          grade_level: hash.grade_level,
          phone: hash.phone_number,
        }, {
          headers: { Authorization: `Token ${AccessToken.get()}` },
        }).then(() => {
          cookie.set('update_footprint', new Date().getTime(), {
            domain: config.auth_token_cookie_domain,
            path: '/',
          })
          hotjarTrigger('register_done')
          this.applicationDone()
        })
      }).catch(() => {
        this.loader.classList.add('hide')
      })
      return hash
    }

    return this.loader.classList.add('hide')
  }

  applicationDone() {
    window.location = `/application_done${window.location.search}`
  }

  defaultSelectInputOptions(inputPlaceholder) {
    return {
      placeholder: inputPlaceholder,
      theme: 'qstrap',
    }
  }

  schoolSelectInputOptions() {
    const options = this.defaultSelectInputOptions(intl.get('account.your_school'))

    options.minimumInputLength = 1
    options.ajax = {
      url: this.state.schoolsAjaxSource,
      dataType: 'json',
      data(params) {
        return { query: params.term }
      },
    }

    return options
  }

  customSchoolToggle() {
    this.setState({ customSchoolInput: !this.state.customSchoolInput })

    if (!this.state.customSchoolInput) {
      this.inputs.school.value = '-'
      this.inputs.custom_school.value = ''
    } else {
      this.inputs.school.value = ''
      this.inputs.custom_school.value = '-'
    }
  }

  render() {
    const { currentUser } = this.props
    if (currentUser.vp_meta) window.location = '/'

    return (
      <div>
        <form onSubmit={this.handleSubmit} ref={c => this.container.form = c}>
          <h6 className="bold m-b-md">
            Hi {currentUser.name}, welcome to Quipper!
          </h6>
          <div className="text-center faded m-b-md">{intl.get('account.please_fill_notice')}</div>

          <div className={`${this.state.customSchoolInput ? 'hidden' : ''}`}>
            <Input
              ref={c => this.inputs.province = c}
              icon="province"
              type="select"
              selectOptions={this.state.provinces}
              options={this.defaultSelectInputOptions(intl.get('account.province_of_your_school'))}
              name="province"
              validations={this.state.customSchoolInput ? [] : ['required']}
              label={intl.get('account.province_of_your_school')}
              callback={this.fillCityOptions}
              embedErrorsInfo
            />

            <Input
              ref={c => this.inputs.city = c}
              icon="city"
              type="select"
              selectOptions={this.state.cities}
              options={this.defaultSelectInputOptions(intl.get('account.city_of_your_school'))}
              name="city"
              validations={this.state.customSchoolInput ? [] : ['required']}
              label={intl.get('account.city_of_your_school')}
              callback={this.showSchoolSelect}
              containerClassName={!this.state.citiesVisible ? 'hidden' : ''}
              embedErrorsInfo
            />

            <Input
              ref={c => this.inputs.school = c}
              icon="school"
              type="select"
              name="school"
              options={this.schoolSelectInputOptions()}
              validations={this.state.customSchoolInput ? [] : ['required']}
              label={intl.get('account.your_school')}
              containerClassName={!this.state.schoolsVisible ? 'hidden' : ''}
              embedErrorsInfo
            />

            <div className={`text-left form-group customSchoolButton ${!this.state.schoolsVisible ? 'hidden' : ''}`}>
              <a onClick={this.customSchoolToggle}>Klik disini bila sekolah kamu tidak ada di dalam daftar</a>
            </div>
          </div>

          <div className={`${this.state.customSchoolInput ? '' : 'hidden'}`}>
            <Input
              ref={c => this.inputs.custom_school = c}
              icon="school"
              name="custom_school"
              label={intl.get('account.your_school')}
              validations={this.state.customSchoolInput ? ['required'] : []}
              embedErrorsInfo
            />

            <div className="text-left form-group customSchoolButton">
              <a onClick={this.customSchoolToggle}>Pilih sekolah di dalam daftar Quipper</a>
            </div>
          </div>

          <hr className="m-t-lg p-b-sm" />

          <Input
            ref={c => this.inputs.grade_level = c}
            name="grade_level"
            type="selectButton"
            selectOptions={this.state.gradeLevels}
            label={intl.get('account.your_grade_level')}
            validations={['required']}
            callback={this.setSchoolMajor}
            defaultValue={this.props.currentUser.grade_level}
            embedErrorsInfo
          />

          <Input
            ref={c => this.inputs.school_major = c}
            name="school_major"
            type="radioButton"
            label={intl.get('account.your_school_major')}
            options={['natural_sciences', 'social_sciences', 'other', 'not_yet_decided']}
            validations={['required']}
            containerClassName={!this.state.majorsVisible ? 'hidden' : ''}
            translationKey="school_majors"
            embedErrorsInfo
          />

          <hr className="m-t-lg p-b-sm" />

          <Input
            ref={c => this.inputs.phone_number = c}
            icon="flag-indonesia"
            type="tel"
            name="phone_number"
            label={intl.get('account.phone_number')}
            validations={['required', 'phone_number']}
            defaultValue={this.props.currentUser.phone}
            embedErrorsInfo
          />

          <Input
            ref={c => this.inputs.parent_phone_number = c}
            icon="flag-indonesia"
            type="tel"
            name="parent_phone_number"
            label={intl.get('account.parent_phone_number')}
            validations={['required', 'phone_number']}
            embedErrorsInfo
          />

          <FormGroup className="m-t-lg" check>
            <Button color="primary" type="submit" block onClick={this.handleSubmit} className="icon-loading-container">
              <i className="icon icon-loading icon-loading-center hide" ref={c => this.loader = c} />
              {intl.get('next')}
            </Button>
          </FormGroup>
        </form>

        <Modal autoFocus={false} isOpen={this.state.openNotice} fade={false} className="CompleteSignUpNotice">
          <ModalBody className="text-center">
            <p>Maaf data profilemu belum lengkap, yuk lengkapi dulu untuk melanjutkan hanya 1 menit</p>
            <a href="javascript:void(0)" className="btn btn-primary" onClick={() => { this.setState({ openNotice: false }) }}>Lengkapi</a>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

Application.defaultProps = {
  currentUser: {},
}

export default branch({
  currentUser: ['serverProps', 'currentUser'],
}, Application)
